var fromPairs = function fromPairs(pairs) {
	return pairs.reduce(function (obj, _ref) {
		var key = _ref[0],
		    value = _ref[1];

		obj[key] = value;
		return obj;
	}, {});
};

export default (function (query) {
	return fromPairs(query.split('&').map(function (pair) {
		return pair.split('=').map(decodeURIComponent);
	}));
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@livechat/url-utils/es/decodeQueryString.js
// module id = 529
// module chunks = 0